var map = {
	".": [
		5399
	],
	"./": [
		5399
	],
	"./helloWorld": [
		1845,
		310
	],
	"./helloWorld.scss": [
		1372,
		28
	],
	"./helloWorld.ts": [
		1845,
		310
	],
	"./index": [
		5399
	],
	"./index.ts": [
		5399
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3085;
module.exports = webpackAsyncContext;